// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-height{min-height:100%}.custom-container-height{min-height:100vh;background-image:-webkit-gradient(linear,left top,right top,from(#37cf37),to(#37cf37));background-image:linear-gradient(90deg,#37cf37,#37cf37)}.custom-footer{color:#fff;margin-top:2rem;font-weight:500;font-family:Poppins,sans-serif}.card-style{background-color:#fff}.rounded-card{border-radius:12px}.title-style{font-size:18px;font-weight:500;letter-spacing:.5px}", ""]);
// Exports
module.exports = exports;
